/* unplugin-vue-components disabled */import { render } from "./SearchIndex.vue?vue&type=template&id=5700c694&scoped=true"
import script from "./SearchIndex.vue?vue&type=script&lang=js"
export * from "./SearchIndex.vue?vue&type=script&lang=js"

import "./SearchIndex.vue?vue&type=style&index=0&id=5700c694&lang=sass"
import "./SearchIndex.vue?vue&type=style&index=1&id=5700c694&lang=sass&scoped=true"

import exportComponent from "/app/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5700c694"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QPagination});
